import SocketCentrifugeBase from '@/api/sockets/SocketCentrifugeBase';
import { Callback, Dict } from '@/types/utility';
import { MeasurementSocketEvents } from '@/api/sockets/MeasurementSocket';

export enum SampleInjectionSocketEvents {
  STUB = '',
}

enum SampleInjectionSocketRPC {
  GET = 'sample_injection.get',
  STOP = 'sample_injection.stop',
  ARCHIVE = 'sample_injection.archive',
  RESTORE = 'sample_injection.restore',
  UPDATE = 'sample_injection.update',
}

export default class SampleInjectionSocket extends SocketCentrifugeBase<
  SampleInjectionSocketEvents,
  SampleInjectionSocketRPC
> {
  private static connections: Dict<SampleInjectionSocket> = {};

  protected listeners: Record<SampleInjectionSocketEvents, Callback[]> = {
    [MeasurementSocketEvents.STUB]: [] as Callback<[data: object]>[],
  };

  private constructor(
    public id: number,
    onConnect?: Callback<
      [SocketCentrifugeBase<SampleInjectionSocketEvents, SampleInjectionSocketRPC>]
    >,
  ) {
    super(`personal:sample-injection-${id}`, {
      handleEvents: () => null,
      onConnect,
    });

    this.id = id;

    this.dataAddedToEveryRequest = { injection_id: this.id };
  }

  public static start(
    id: number,
    onConnect?: Callback<
      [SocketCentrifugeBase<SampleInjectionSocketEvents, SampleInjectionSocketRPC>]
    >,
  ) {
    const connection = SampleInjectionSocket.connections[id];
    if (connection) {
      connection.addSession();

      onConnect?.(connection);
      return connection;
    }

    SampleInjectionSocket.connections[id] = new SampleInjectionSocket(id, onConnect);

    return SampleInjectionSocket.connections[id];
  }

  public close(listenersGroupId: string): boolean {
    const isClosed = super.close(listenersGroupId);

    if (isClosed) {
      delete SampleInjectionSocket.connections[this.id];
    }

    return isClosed;
  }

  async get() {
    const data = await this.sendNamedRPC(SampleInjectionSocketRPC.GET);
    return data.injection;
  }

  stop() {
    return this.sendNamedRPC(SampleInjectionSocketRPC.STOP);
  }

  archive() {
    return this.sendNamedRPC(SampleInjectionSocketRPC.ARCHIVE);
  }

  restore() {
    return this.sendNamedRPC(SampleInjectionSocketRPC.RESTORE);
  }

  update(injection) {
    return this.sendNamedRPC(SampleInjectionSocketRPC.UPDATE, { injection });
  }
}
